import { useRef } from "react";
import { HiOutlineUpload } from "react-icons/hi";

const ImageDropZone = ({ imageObject, url, setImageObject, sx }) => {
    const inputFile = useRef(null);
    const inputPreviewFile = useRef(null);

    const onClickAssetUpload = (type) => {
        if (type === "nft") {
            if (inputFile.current) {
                inputFile.current.click();
            }
        } else if (type === "preview") {
            if (inputPreviewFile.current) {
                inputPreviewFile.current.click();
            }
        }
    };

    const onDropFile = (e) => {
        e.preventDefault();
        if (e.dataTransfer && e.dataTransfer.files.length !== 0) {
            const files = e.dataTransfer.files;
            setImageObject(files[0]);
        }
    };

    const onChangeFile = ({ currentTarget: { files, name } }) => {
        if (files && files.length && name === "nftMedia")
            setImageObject(files[0]);
    };

    return (
        <div
            className="w-full h-full overflow-hidden relative cursor-pointer hover:opacity-70"
            aria-label="Select an image, video, auto or 3D model file"
            onClick={() => onClickAssetUpload("nft")}
            style={sx}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => onDropFile(e)}
        >
            <input
                id="media"
                name="nftMedia"
                accept="image/*,webgl/*,.glb,.gltf"
                type="file"
                autoComplete="off"
                tabIndex={-1}
                style={{ display: "none" }}
                ref={inputFile}
                onChange={onChangeFile}
            />
            {imageObject ? (
                <>
                    <button
                        type="button"
                        className="ace-modal-close-button absolute right-0 z-[1]"
                        onClick={(e) => {
                            e.stopPropagation();
                            inputFile.current.value = null;
                            setImageObject(null);
                        }}
                    >
                        <svg
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </button>
                    <img
                        className="w-full"
                        src={
                            url
                                ? url
                                : imageObject.url
                                ? imageObject.url
                                : URL.createObjectURL(imageObject)
                        }
                        alt="template"
                    />
                </>
            ) : (
                <div className="flex flex-col justify-center items-center w-full h-full font-normal size-xs">
                    <HiOutlineUpload className="w-8 h-8" />
                    <span>PNG, JPG, GIF, WEBP. Max 1Gb.</span>
                </div>
            )}
        </div>
    );
};

export default ImageDropZone;

// const DropZoneBox = styled(Box)`
//     width: 250px;
//     height: 200px;
//     background: rgba(0, 0, 0, 0.07);
//     border: 1px solid rgba(255, 255, 255, 0.22);
//     backdrop-filter: blur(39px);
//     border-radius: 7px;
//     padding: 5px;
//     overflow: hidden;
//     position: relative;
//     margin: 10px 0px 20px 10px;
// `;
